import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import Nav, {
  AkContainerTitle,
  AkCreateDrawer,
  AkNavigationItem,
  AkSearchDrawer,
} from '@atlaskit/navigation';
import DashboardIcon from '@atlaskit/icon/glyph/dashboard';
import GearIcon from '@atlaskit/icon/glyph/settings';
// import SearchIcon from '@atlaskit/icon/glyph/search';
import ArrowleftIcon from '@atlaskit/icon/glyph/arrow-left';

import AkAvatar from '@atlaskit/avatar';

import SearchDrawer from '../components/SearchDrawer';
// import MarketplaceIcon from '@atlaskit/icon/glyph/marketplace';
import ScreenIcon from '@atlaskit/icon/glyph/screen';
import MediaServicesBlurIcon from '@atlaskit/icon/glyph/media-services/blur';
import DocumentsIcon from '@atlaskit/icon/glyph/documents';
import CalendarFilledIcon from '@atlaskit/icon/glyph/calendar-filled';
import DepartmentIcon from '@atlaskit/icon/glyph/department';
import LocationIcon from '@atlaskit/icon/glyph/location';
import EditorInfoIcon from '@atlaskit/icon/glyph/editor/info';
import AccountDrawer from '../components/AccountDrawer';
import HelpDropdownMenu from '../components/HelpDropdownMenu';

import { CompassGlyph } from './icons/compass';
import Icon from '@atlaskit/icon';

import Objects24Object24StoryIcon from '@atlaskit/icon/glyph/objects/24/object-24-story';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class StarterNavigation extends React.Component {
  state = {
    navLinks: [
      ['/', 'Dashboard', DashboardIcon],
      ['/pointofinterests', 'Point of Interests', LocationIcon],
      ['/categories', 'Categories', DepartmentIcon],
      ['/kiosks', 'Kiosks', ScreenIcon],
      ['/amenities', 'Amenities', EditorInfoIcon],
      ['/floorplans', 'Floorplans', MediaServicesBlurIcon],
      ['/medias', 'Media Manager', DocumentsIcon],
      ['/events', 'Events', CalendarFilledIcon],
      ['/settings', 'Settings', GearIcon],
    ]
  };

  static contextTypes = {
    navOpenState: PropTypes.object,
    router: PropTypes.object,
  };

  openDrawer = (openDrawer) => {
    this.setState({ openDrawer });
  };

  shouldComponentUpdate(nextProps, nextContext) {
    return true;
  };

  render() {
    const backIcon = <ArrowleftIcon label="Back icon" size="medium" />;
    // const globalPrimaryIcon = <AtlassianIcon label="Atlassian icon" size="xlarge" />;
    const globalPrimaryIcon = <Icon glyph={CompassGlyph} label="Custom icon" size="large" />;

    const headerTitle = <Link className="main-link" to={`/`}><AkContainerTitle icon={<Icon glyph={Objects24Object24StoryIcon} label="Custom icon" size="medium" />} text={`${this.props.username}`} /></Link>;

    return (
      <Nav
        isOpen={this.context.navOpenState.isOpen}
        width={this.context.navOpenState.width}
        onResize={this.props.onNavResize}
        containerHeaderComponent={() => { return headerTitle; }}
        globalPrimaryIcon={globalPrimaryIcon}
        globalPrimaryItemHref="/"
        // globalSearchIcon={<SearchIcon label="Search icon" />}
        hasBlanket
        drawers={[
          <AkSearchDrawer
            backIcon={backIcon}
            isOpen={this.state.openDrawer === 'search'}
            key="search"
            onBackButton={() => this.openDrawer(null)}
            primaryIcon={globalPrimaryIcon}
          >
            <SearchDrawer
              onResultClicked={() => this.openDrawer(null)}
              onSearchInputRef={(ref) => {
                this.searchInputRef = ref;
              }}
            />
          </AkSearchDrawer>,
          <AkCreateDrawer
            backIcon={backIcon}
            isOpen={this.state.openDrawer === 'account'}
            key="create"
            onBackButton={() => this.openDrawer(null)}
            primaryIcon={globalPrimaryIcon}
          >
            <AccountDrawer
              onItemClicked={() => this.openDrawer(null)}
            />
          </AkCreateDrawer>
        ]}
        globalSecondaryActions={[
          // <Link to="/logout"><AkAvatar size="small" /></Link>
          <a onClick={() => this.openDrawer('account')}><AkAvatar size="small" /></a>
        ]}
        // globalCreateIcon={<MenuIcon label="Create icon" />}
        globalHelpItem={HelpDropdownMenu}
        onSearchDrawerOpen={() => this.openDrawer('search')}
        onCreateDrawerOpen={() => this.openDrawer('create')}
      >
        {
          this.state.navLinks.map(link => {
            const [url, title, Icon] = link;
            return (
              <Link className="main-link" key={url} to={url}>
                <AkNavigationItem
                  icon={<Icon label={title} size="medium" />}
                  text={title}
                  isSelected={this.context.router.route.location.pathname === url}
                />
              </Link>
            );
          }, this)
        }
      </Nav>
    );
  }
}

const mapStateToProps = state => ({
  username: state.account.username
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(StarterNavigation);


// WEBPACK FOOTER //
// ./src/components/StarterNavigation.js